/* eslint-disable default-case */
import {
    GET_CONTENT_TEMPLATE
} from '../actions/contentManagementActions';

const initialState = {
};

export function contentManagementTemplate(state = initialState, action)
{
    switch (action.type)
    {
        case GET_CONTENT_TEMPLATE.pending:
        {
            return {
                ...state,
                iconIsFetching: true
            };
        }
        case GET_CONTENT_TEMPLATE.fulfilled:
        {
            return {
                ...state,
                iconTemplate: action.payload,
                lastError: {},
                iconIsFetching: false
            };
        }

        case GET_CONTENT_TEMPLATE.rejected:
        {
            return {
                ...state,
                iconTemplate: undefined,
                lastError: action.payload,
                iconIsFetching: false
            };
        }

    }

    return state;
}
